export const isLocaleSweden = (locale) =>
  locale === 'sv_SE' || locale === 'sv-SE';

export const isLocaleNorway = (locale) =>
  locale === 'nb_NO' || locale === 'nb-NO';

export const isLocaleDenmark = (locale) =>
  locale === 'da_DK' || locale === 'da-DK';

export const isLocaleFinland = (locale) =>
  locale === 'fi_FI' || locale === 'fi-FI';

export const isLocaleNordics = (locale) =>
  isLocaleSweden(locale) ||
  isLocaleNorway(locale) ||
  isLocaleDenmark(locale) ||
  isLocaleFinland(locale);
